<template>
	<div class="circle-sender-container">
		<div class="circle-sender-wrap">
			<div class="circle-sender-custom">
				<div class="circle-sender-c-title">
					<fieldset>
					    <legend>发送账号</legend>
						<div class="circle-sender-c-wrap">
							<div class="circle-sender-c-item" :class="{'circle-sender-c-item-active': customIsSelect(custom,true)}" v-for="custom in customList" @click="selectCustom(custom)">
								<span class="circle-sender-c-name">{{custom.identity !== null ? custom.identity : custom.wx_name}}</span>
								<span class="circle-sender-c-choose"></span>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
			<div class="circle-sender-template">
				<div class="circle-sender-t-wrap">
					<div class="circle-sender-t-show">
						<div class="circle-sender-ts-icon"></div>
						<div class="circle-sender-ts-text">朋友圈模板</div>
					</div>
					<div class="circle-sender-t-choose" @click="chooseTemp">
						<div class="circle-sender-tc-text">{{circleSelectText}}</div>
						<div class="circle-sender-tc-icon"></div>
					</div>
				</div>
			</div>
			<div class="circle-sender-template">
				<div class="circle-sender-t-wrap">
					<div class="circle-sender-t-show">
						<div class="circle-sender-ts-icon circle-sender-ts-aite-icon"></div>
						<div class="circle-sender-ts-text">提醒谁看</div>
					</div>
					<div class="circle-sender-t-choose" @click="chooseRemind">
						<div class="circle-sender-tc-text">{{remindFans.length === 0 ? '选择粉丝' : '提醒'+remindFans.length+'个粉丝'}}</div>
						<div class="circle-sender-tc-icon"></div>
					</div>
				</div>
			</div>
			<div class="circle-sender-template">
				<div class="circle-sender-t-wrap">
					<div class="circle-sender-t-show">
						<div class="circle-sender-ts-icon circle-sender-ts-auth-icon"></div>
						<div class="circle-sender-ts-text">谁可以看</div>
					</div>
					<div class="circle-sender-t-choose" @click="chooseAuth">
						<div class="circle-sender-tc-text">{{authName}}</div>
						<div class="circle-sender-tc-icon"></div>
					</div>
				</div>
			</div>
			<div class="circle-sender-template">
				<div class="circle-sender-t-wrap">
					<div class="circle-sender-t-show">
						<div class="circle-sender-ts-icon circle-sender-ts-auth-icon"></div>
						<div class="circle-sender-ts-text">我的位置</div>
					</div>
					<div class="circle-sender-t-choose" @click="choosePosition">
						<div class="circle-sender-tc-text">{{position.title}}</div>
						<div class="circle-sender-tc-icon"></div>
					</div>
				</div>
			</div>
			<div class="circle-sender-tools-box">
				<circle-tools  
					@emoji-call="emojiCall($event)" 
					@circle-tools-call="circleToolsCall($event)"
					ref="circleSenderTools"
					:circleTemp = "circleTemp"
					:inputFocus="inputFocus">
				</circle-tools>
			</div>
			<div class="circle-sender-input">
				<chatting-input 
					:chatToolsData="chatToolsData" 
					:defaultMsg = "circleTemp.id === undefined ? '' :circleTemp.content"
					@chat-input-msg="chatInputMsg($event)" 
					@chat-input-focus="chatInputFocus($event)"
					ref="circleSenderInput"
					key="circle-sender-input">
				</chatting-input>
			</div>
			<div class="circle-sender-menu">
				<div class="circle-sender-m-wrap">
					<div class="circle-sender-ml">
						<span @click="addComment">添加评论</span>
						<span style="background-color: #FFFFFF;color: #666666;">{{commentList.length}}条评论</span>
					</div>
					<div class="circle-sender-mr">
						<span class="circle-sender-mr-count">{{senderData.content.length}}/800</span>
						<span class="circle-sender-mr-send" @click="sendMoment">发表</span>
					</div>
				</div>
			</div>
			<div class="circle-sender-comment">
				<div class="circle-sender-comment-item" v-for="(comment,key) in commentList" :key="'circle-sender-comment-'+key">
					<div class="circle-sender-c-text">
						<textarea name="" id="" v-model="comment.content"></textarea>
					</div>
					<div class="circle-sender-c-tools">
						<div class="circle-sender-ct-time">
							<label>延时发送</label>
							<input type="text" v-model="comment.delayHour">
							<span>小时</span>
							<input type="text" v-model="comment.delayMinute">
							<span>分钟</span>
							<span class="circle-sender-ctt-c" @click="delayTime(key,3)">3分钟</span>
							<span class="circle-sender-ctt-c" @click="delayTime(key,10)">10分钟</span>
							<span class="circle-sender-ctt-c" @click="delayTime(key,15)">15分钟</span>
							<span class="circle-sender-ctt-c" @click="delayTime(key,30)">30分钟</span>
						</div>
						<div class="circle-sender-ct-options">
							<div class="circle-sender-cto-view" v-show="comment.showEmoji">
								<emoji :key="'circle-sender-comment-emoji-'+key" @emoji-call="commentEmojiCall($event,key)"></emoji>
							</div>
							<span class="circle-sender-cto-emoji" @click="commentEmojiClick(key)"></span>
							<span @click="commentEmojiDel(key)">删除</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CircleTools from './CircleTools.vue'
	import Emoji from '../../components/Emoji.vue'
	import ChattingInput from '../../components/ChattingInput.vue'
	import {pushSendMoment} from '../../socket/socketEventSender.js'
	import {webMomentsSave} from '../../network/web/moments.js'

	export default{
		name:'CircleSender',
		props:{
			customList:{
				type: Array,
				default:[]
			},
			circleTempData:{
				type: Object,
				default: {}
			},
			authFans:{
				type: Object,
				default: {
					type:1,
					list:[]
				}
			},
			remindFans:{
				type: Array,
				default:[]
			},
			position:{
				type: Object,
				default: {
				}
			}
		},
		data(){
			return{
				circleSelectText:'选择模板',
				commentList:[],
				chatToolsData:{},
				inputFocus:0,
				selectCustomList:[],
				circleTemp:{},
				senderData:{
					id:0,
					type: 1,
					content: '',
					imgUrl: [],
					cover: '',
					urlContent:'',
					url: '',
				}
			}
		},
		components:{
			CircleTools,
			Emoji,
			ChattingInput
		},
		methods:{
			// 数据初始化
			initData(){
				this.circleSelectText = '选择模板'
				this.circleTemp = {}
				this.commentList = []
				this.senderData = {
					id:0,
					type: 1,
					content: '',
					imgUrl: [],
					cover: '',
					urlContent:'',
					url: '',
				}
			},
			
			// 客服点击
			selectCustom(custom){
				let selectData = this.customIsSelect(custom)
				if(selectData.isSelect){
					this.selectCustomList.splice(selectData.index,1)
				}else{
					this.selectCustomList.push({
						id: custom.id,
						open_id: custom.open_id,
						phone_id: custom.phone_id
					})
				}
			},
			
			// 判断客服是否选中
			customIsSelect(custom,backBoolean){
				let isSelect = false
				let index = 0
				for (let i = 0; i < this.selectCustomList.length; i++) {
					if(this.selectCustomList[i].id === custom.id){
						isSelect = true
						index = i
						break
					}
				}
				if(backBoolean){
					return isSelect
				}
				return {
					isSelect: isSelect,
					index: index
				}
			},
			
			// 添加评论
			addComment(){
				this.commentList.push({
						content:'',
						showEmoji: false,
						delayMinute: 0,
						delayHour:0
				})
			},
			
			// 评论中emoji点击
			commentEmojiClick(index){
				for (let i = 0; i < this.commentList.length; i++) {
					if(i === index){
						this.commentList[i].showEmoji = !this.commentList[i].showEmoji
					}else{
						this.commentList[i].showEmoji = false
					}
				}
			},
			
			// 评论删除
			commentEmojiDel(index){
				this.commentList.splice(index,1)
			},
			
			// 延时时间点击
			delayTime(index,time){
				this.commentList[index].delayMinute = time
			},
			
			// 朋友圈模板选择点击
			chooseTemp(){
				this.$emit("choose-temp-call")
			},
			
			// 给谁看选择点击
			chooseAuth(){
				if(this.selectCustomList.length === 0){
					CHAT_LAYER.msg("请选择客服",{icon:2})
					return
				}
				if(this.selectCustomList.length > 1){
					CHAT_LAYER.msg("只能选择单个客服",{icon:2})
					return
				}
				this.$emit("choose-Auth-call",this.selectCustomList[0].id)
			},
			
			// @谁菜单点击
			chooseRemind(){
				if(this.selectCustomList.length === 0){
					CHAT_LAYER.msg("请选择客服",{icon:2})
					return
				}
				if(this.selectCustomList.length > 1){
					CHAT_LAYER.msg("只能选择单个客服",{icon:2})
					return
				}
				this.$emit("choose-remind-call",this.selectCustomList[0].id)
			},
			
			// 选择位置
			choosePosition(){
				this.$emit("choose-position-call")
			},
			
			// 发表朋友圈
			sendMoment(){
				if(this.senderData.type == 1){
					if(this.senderData.content === '' && this.senderData.imgUrl.length === 0){
						CHAT_LAYER.msg('发圈内容为空',{icon:2})
						return
					}	
				}else if(this.senderData.type == 2){
					if(this.senderData.imgUrl.length === 0){
						CHAT_LAYER.msg('视频内容为空',{icon:2})
						return
					}	
				}else if(this.senderData.type == 3){
					if(this.senderData.imgUrl.length === 0 || this.senderData.url === '' || this.senderData.urlContent === ''){
						CHAT_LAYER.msg('链接内容为空',{icon:2})
						return
					}	
				}
				if(this.selectCustomList.length === 0){
					CHAT_LAYER.msg('请选择客服',{icon:2})
					return
				}
				// 去除引用，避免监听的属性变化，引起数据错乱
				let momentsData = JSON.parse(JSON.stringify(this.senderData))
				// 只有选择一个粉丝的情况下，才触发@和给谁看
				if(this.selectCustomList.length === 1){
					momentsData.auth = this.authFans
					momentsData.remindFans = this.remindFans
				}
				// 拼接评论
				let comment = []
				if(this.commentList.length>0){
					for (let i = 0; i < this.commentList.length; i++) {
						comment.push(this.commentList[i].content)
					}
				}
				momentsData.comment = comment
				momentsData.content = momentsData.content.replace(/<br\/>/g, '<br>')
				momentsData.qq_maps = this.position
				
				// 循环推送
				for (let i = 0; i < this.selectCustomList.length; i++) {
					webMomentsSave(momentsData,this.selectCustomList[i].id,this.selectCustomList[i].open_id,data=>{
						if(data > 0){
							pushSendMoment(momentsData,this.selectCustomList[i].open_id,this.selectCustomList[i].phone_id,data)
						}
					})
				}
				this.$refs.circleSenderInput.clearInput()
				this.$refs.circleSenderTools.init()
				this.initData()
				CHAT_LAYER.msg('指令已推送，请稍后查看发送结果。',{icon:1})
			},
			
			// 回调-工具栏表情点击回调
			emojiCall(emoji){
				this.chatToolsData = {
					type:'emoji',
					data:emoji
				}
			},
			
			// 回调-输入框输入回调
			chatInputMsg(val){
				// 只取数值第一个元素信息
				for (let i = 0; i < val.length; i++) {
					if(val[i].type == 'text'){
						this.senderData.content = val[i].content
						break
					}
				}
			},
			
			// 回调-聚焦回调
			chatInputFocus(val){
				this.inputFocus = val
			},
			
			// 回调-工具栏数据回调-所有数据
			circleToolsCall(data){
				let type = 0
				let imgUrl = ''
				let cover = ''
				let url_content = ''
				let url = ''
				if(data.tType == 0){
					type = 1
				}else if(data.tType == 1){
					type = 1
					imgUrl = data.uploadedFiles
				}else if(data.tType == 2){
					type = 2
					imgUrl = data.uploadedFiles.length > 0 ? data.uploadedFiles[0] : ''
					cover = data.videoPic.length > 0 ? data.videoPic[0] : ''
				}else if(data.tType == 3){
					type = 3
					imgUrl = data.uploadedFiles.length > 0 ? data.uploadedFiles[0] : ''
					url_content = data.linkText
					url = data.link
				}
				this.senderData.type = type
				this.senderData.imgUrl = imgUrl
				this.senderData.cover = cover
				this.senderData.urlContent = url_content
				this.senderData.url = url
			},
			
			// 评论模块的标签点击回调
			commentEmojiCall(data,index){
				this.commentList[index].content += '['+data.title+']'
				this.commentList[index].showEmoji = false
			}
		},
		watch:{
			// 监听模板数据变化
			circleTempData(nVal){
				this.senderData.content = nVal.content
				this.circleSelectText = nVal.title
				this.circleTemp = nVal
				// 渲染评论
				if(nVal.auto_comment !== undefined){
					try{
						let auto_comment = JSON.parse(nVal.auto_comment)
						for (var i = 0; i < auto_comment.length; i++) {
							this.commentList.push({
									content: auto_comment[i],
									showEmoji: false,
									delayMinute: 0,
									delayHour:0
							})
						}
					}catch(e){
						
					}
				}
			}
		},
		
		computed:{
			// 全选名称判断
			authName(){
				let name = '公开'
				switch(this.authFans.type){
					case 1:
						name = '公开'
						break
					case 2:
						name = '私密'
						break
					case 3:
						name = '部分可见'
						break
					case 4:
						name = '不给谁看'
						break
				}
				if(this.authFans.list.length > 0 && this.authFans.type > 2){
					name += '（共'+this.authFans.list.length+'个粉丝）'
				}
				return name
			}
		}
	}
</script>

<style>
	.circle-sender-container{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		color: #888888;
	}
	.circle-sender-container .circle-sender-wrap{
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.circle-sender-wrap .circle-sender-custom{
		padding: 10px 0;
		width: 100%;
		border-bottom: 1px solid #e3e3e3;
	}
	.circle-sender-custom .circle-sender-c-title{
		width: 100%;
		font-size: 16px;
		padding: 10px;
		box-sizing: border-box;
	}
	.circle-sender-c-title fieldset{
		border: 1px solid #e3e3e3;
	}
	.circle-sender-c-title fieldset legend{
		margin-left: 20px;
		padding: 0 10px;
	}
	.circle-sender-custom .circle-sender-c-wrap{
		min-height: 40px;
		max-height: 120px;
		overflow-x: hidden;
		overflow-y: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
	}
	.circle-sender-c-wrap .circle-sender-c-item{
		height: 28px;
		min-width: 60px;
		border: 1px solid #e2e2e2;
		margin: 5px;
		border-radius: 2px;
		cursor: pointer;
		color: #666666;
	}
	.circle-sender-c-wrap .circle-sender-c-item-active{
		border: 1px solid #42B983 !important;
	}
	.circle-sender-c-item span{
		display: inline-block;
		height: 28px;
		line-height: 28px;
		vertical-align: middle;
	}
	.circle-sender-c-item .circle-sender-c-name{
		padding: 0 5px;
		background-color: #e2e2e2;
	}
	.circle-sender-c-item .circle-sender-c-choose{
		width: 28px;
		height: 28px;
		background-position: center;
		background-size: 22px 22px;
		background-repeat: no-repeat;
		background-image: url(../../assets/img/correct-48.png);
	}
	.circle-sender-c-item-active>.circle-sender-c-name{
		background-color: #42B983;
		color: #ffffff;
	}
	.circle-sender-c-item-active>.circle-sender-c-choose{
		background-image: url(../../assets/img/correct-48-active.png);
	}
	.circle-sender-wrap .circle-sender-template{
		width: 100%;
		height: 46px;
		line-height: 46px;
		border-bottom: 1px solid #e3e3e3;
		overflow: hidden;
	}
	.circle-sender-template .circle-sender-t-wrap{
		padding: 0 10px;
		height: 46px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		overflow: hidden;
	}
	.circle-sender-t-wrap .circle-sender-t-show{
		height: 46px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.circle-sender-t-show .circle-sender-ts-icon{
		width: 20px;
		height: 20px;
		margin-right: 10px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		background-image: url(../../assets/img/template-bf-32.png);
	}
	.circle-sender-t-show .circle-sender-ts-auth-icon{
		background-image: url(../../assets/img/friend-bf-32.png) !important;
	}
	.circle-sender-t-show .circle-sender-ts-aite-icon{
		background-image: url(../../assets/img/aite-bf-32.png) !important;
		background-size: 18px auto;
	}
	.circle-sender-t-wrap .circle-sender-t-choose{
		height: 46px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}
	.circle-sender-t-choose .circle-sender-tc-icon{
		width: 22px;
		height: 22px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		background-image: url(../../assets/img/show-bf-32.png);
	}
	.circle-sender-wrap .circle-sender-tools-box{
		width: 100%;
	}
	.circle-sender-wrap .circle-sender-input{
		width: 100%;
		height: 120px;
		padding: 10px;
		box-sizing: border-box;
		overflow: hidden;
		padding-top: 0;
	}
	.circle-sender-input .circle-sender-i-wrap{
		width: 100%;
		height: 100%;
		border: 1px solid #e3e3e3;
		border-radius: 4px;
		padding: 10px;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
		outline: none;
	}
	.circle-sender-i-wrap:focus{
		border: 1px solid #42B983;
	}
	.circle-sender-i-wrap img{
		max-width: 100%;
	}
	.circle-sender-wrap .circle-sender-menu{
		padding: 10px;
		height: 30px;
		line-height: 30px;
		overflow: hidden;
	}
	.circle-sender-menu .circle-sender-m-wrap{
		height: 30px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
	}
	.circle-sender-m-wrap .circle-sender-ml,.circle-sender-m-wrap .circle-sender-mr{
		height: 30px;
		overflow: hidden;
	}
	.circle-sender-ml span,.circle-sender-mr span{
		height: 30px;
		padding: 0 10px;
		display: inline-block;
		vertical-align: middle;
		background-color: #009688;
		color: #e7e7e7;
		border-radius: 2px;
		cursor: pointer;
		margin: 0 5px;
	}
	.circle-sender-mr .circle-sender-mr-send{
		background-color: #1178b5;
		user-select: none;
	}
	.circle-sender-mr .circle-sender-mr-count{
		background-color: #FFFFFF;
		color: #666666;
	}
	.circle-sender-wrap .circle-sender-comment{
		padding: 0 10px;
		user-select: none;
	}
	.circle-sender-comment-item{
		padding: 5px 0;
	}
	.circle-sender-comment .circle-sender-c-text{
		width: 100%;
	}
	.circle-sender-c-text textarea{
		width: 100%;
		height: 60px;
		border: 1px solid #e3e3e3;
		padding: 5px;
		box-sizing: border-box;
		line-height: 16px;
		resize: none;
		border-radius: 4px;
		color: #888888;
	}
	.circle-sender-comment .circle-sender-c-tools{
		height: 36px;
		line-height: 36px;
		display: flex;
		justify-content: space-between;
	} 
	.circle-sender-ct-time > *{
		display: inline-block;
		vertical-align: middle;
		margin-right: 5px;
	}
	.circle-sender-ct-time > input{
		border: 1px solid #CCCCCC;
		width: 20px;
		height: 20px;
		padding: 0 5px;
		color: #666666;
	}
	.circle-sender-ct-time .circle-sender-ctt-c{
		background-color: #009688;
		color: #FFFFFF;
		height: 18px;
		line-height: 18px;
		padding: 2px 8px;
		cursor: pointer;
	}
	.circle-sender-ct-options{
		position: relative;
	}
	.circle-sender-ct-options .circle-sender-cto-view{
		position: absolute;
		width: 405px;
		height: 200px;
		bottom: 40px;
		right: 0;
	}
	.circle-sender-cto-view .comp-emoji-container::after{
		left: 334px !important;
	}
	.circle-sender-ct-options > span{
		display: inline-block;
		vertical-align: middle;
		background-color: #ff5500;
		color: #FFFFFF;
		height: 18px;
		line-height: 18px;
		padding: 2px 8px;
		cursor: pointer;
	}
	.circle-sender-ct-options .circle-sender-cto-emoji{
		width: 22px;
		height: 22px;
		padding: 0;
		background-color: #FFFFFF;
		background-image: url(../../assets/img/comp-c-tools-emoji.png);
		background-position: center;
		background-size: cover;
		margin-right: 10px;
	}
</style>
